import types from './types';

const toggle = state => ({
  type: types.TOGGLE_SAVE_INVENTORY_MODAL,
  state: state || false,
  processedChangesNotification: null,
  recipients: [],
  markAsChecked: false
});

const updateProcessedChangesNotification = (processedChangesNotification, recipients) => ({
  type: types.UPDATE_PROCESSED_CHANGES_NOTIFICATION,
  processedChangesNotification,
  recipients
});

const setMarkAsChecked = markAsChecked => ({
  type: types.SET_MARK_AS_CHECKED,
  markAsChecked
});

export default {
  toggle,
  updateProcessedChangesNotification,
  setMarkAsChecked
};
